import { createContext, useContext, useEffect, useState } from 'react';

const UserContext = createContext(null);

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  });
  const [idToken, setIdToken] = useState(() => {
    return localStorage.getItem('idToken') || null;
  });
  const [adminImpersonate, setAdminImpersonate] = useState(null);

  useEffect(() => {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  }, [user]);

  useEffect(() => {
    if (idToken) {
      localStorage.setItem('idToken', idToken);
    } else {
      localStorage.removeItem('idToken');
    }
  }, [idToken]);

  const login = (userData, token) => {
    setUser(userData);
    setIdToken(token);
  };

  const logout = () => {
    setUser(null);
    setIdToken(null);
  };

  const updateProfile = (profileData) => {
    setUser((prevUser) => {
      if (!prevUser) {return { ...profileData }; }
      return {
        ...prevUser,
        ...profileData,
      };
    });
  };

  return (
    <UserContext.Provider value={{ user, idToken, setUser, setIdToken, login, logout, updateProfile, adminImpersonate, setAdminImpersonate }}>
      {children}
    </UserContext.Provider>
  );
};
